// extracted by mini-css-extract-plugin
module.exports = {"action":"action_action__2UZvm"};